/**
 * @generated SignedSource<<2e6986e3c0db53d7b4e7ae236935f91f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscriptionStatusEnum = "SUBSCRIBED" | "UNSUBSCRIBED" | "%future added value";
export type RemoveContactFromListInput = {
  contactIdentifier: string;
  mailingListIdentifier: string;
};
export type MailingListDetailsViewRemoveContactFromListMutation$variables = {
  input: RemoveContactFromListInput;
};
export type MailingListDetailsViewRemoveContactFromListMutation$data = {
  readonly removeContactFromList: {
    readonly id: string;
    readonly subscribedCount: number;
    readonly unsubscribedCount: number;
    readonly unsubscribedMembers: ReadonlyArray<{
      readonly contact: {
        readonly emailAddress?: string | null | undefined;
        readonly familyName?: string;
        readonly givenName?: string;
        readonly id: string;
        readonly teamName?: string;
      } | null | undefined;
      readonly contactIdentifier: string;
      readonly mailingListIdentifier: string;
      readonly status: SubscriptionStatusEnum;
      readonly subscribedAt: any;
      readonly unsubscribeReason: string | null | undefined;
      readonly unsubscribedAt: any | null | undefined;
    }>;
  };
};
export type MailingListDetailsViewRemoveContactFromListMutation = {
  response: MailingListDetailsViewRemoveContactFromListMutation$data;
  variables: MailingListDetailsViewRemoveContactFromListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscribedCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsubscribedCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mailingListIdentifier",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactIdentifier",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscribedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsubscribedAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsubscribeReason",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "type": "PersonContact",
  "abstractKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "type": "TeamContact",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListDetailsViewRemoveContactFromListMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MailingList",
        "kind": "LinkedField",
        "name": "removeContactFromList",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListMembership",
            "kind": "LinkedField",
            "name": "unsubscribedMembers",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contact",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MailingListDetailsViewRemoveContactFromListMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MailingList",
        "kind": "LinkedField",
        "name": "removeContactFromList",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListMembership",
            "kind": "LinkedField",
            "name": "unsubscribedMembers",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contact",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f430a0a017f4bfdb6a8a4bd37b9f30a4",
    "id": null,
    "metadata": {},
    "name": "MailingListDetailsViewRemoveContactFromListMutation",
    "operationKind": "mutation",
    "text": "mutation MailingListDetailsViewRemoveContactFromListMutation(\n  $input: RemoveContactFromListInput!\n) {\n  removeContactFromList(input: $input) {\n    id\n    subscribedCount\n    unsubscribedCount\n    unsubscribedMembers {\n      mailingListIdentifier\n      contactIdentifier\n      status\n      subscribedAt\n      unsubscribedAt\n      unsubscribeReason\n      contact {\n        __typename\n        id\n        ... on PersonContact {\n          givenName\n          familyName\n          emailAddress\n        }\n        ... on TeamContact {\n          teamName\n          emailAddress\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4942012b7cedc766441a2743111fb7a";

export default node;
